import { SessionCoach } from "../../models/session.model";

/**
 * Full name of the logged-in user, or an empty string when unavailable.
 * Each part is trimmed so a padded value from the API cannot produce a
 * double-spaced or trailing-space greeting.
 */
export const getUserFullName = (user?: Partial<SessionCoach> | null): string =>
	[user?.firstName, user?.lastName]
		.map((part) => part?.trim())
		.filter(Boolean)
		.join(" ");
